/** @file Animations panel registration (animation list and mix preview). */
import type { PanelEntry } from '../panelEntry';
import { AnimationsPanel } from './AnimationsPanel';

/** A DOM panel: no canvas, so the default renderer. */
export const panel: PanelEntry = { id: 'animations', title: 'panels.animations.title', bindings: [], component: AnimationsPanel };
